import React, {memo, useState} from "react";
import EmojiAnimation from "./emojiAnimation/EmojiAnimation";
import {range} from "../../helpers";
import ReactPlayer from "react-player";

// import Emoji1 from '../../assets/img/common/emojis/emoji_exited_2.png'
// import EmojiHand from '../../assets/img/common/emojis/emoji_hand.png'
// import EmojiSelebrate from '../../assets/img/common/emojis/emoji_selebrate_3.png'
// import EmojiSmile from '../../assets/img/common/emojis/emoji_smile_1.png'
// import Hand1 from '../../assets/img/common/emojis/hand_1.png'
// import Hand2 from '../../assets/img/common/emojis/hand_2.png'
// import Hand3 from '../../assets/img/common/emojis/hand_3.png'
// import Heart from '../../assets/img/common/emojis/heart.png'


window.WowzaPlayer = null;
let config = {
    "license": "PTRL1-mkACG-K3ttT-v74XR-6djew-DAJMR",
    "sourceURL": "https://cdn3.wowza.com/1/cnFjQVpCbTY4K2dC/bDFjK2h5/hls/live/playlist.m3u8",
    "autoPlay": true,
    "volume": "75",
    "mute": false,
    "loop": false,
    "audioOnly": false,
    "uiShowQuickRewind": true,
    "uiShowDurationVsTimeRemaining": true,
    "uiShowBitrateSelector": true,
    "uiQuickRewindSeconds": "30",
    "width": "640",
    "responsive": "true",
    "posterFrameURL": "",
    "uiPosterFrameFillMode": "stretch",
    "uiShowChannelBug": "false",
    "uiChannelBugURL": "",
    "uiChannelBugLocation": "topleft",
    "uiDVRMinDuration": 180000,
    "uiEnableDVR": false,
    "liveStartTimestamp": ""
};

const VideoPlayer = ({videoType, islive, videoSource, handlePlay, handleStop, handleSetTime, handleOnProgress, seek}) => {

    const [emojiNumber, setEmojiNumber] = React.useState(null)
    const [width, setWidth] = React.useState(window.innerWidth * 0.6)
    const [muted, setMuted] = React.useState(true)
    const [videoLoaded, setVideoLoaded] = React.useState(false)
    const player = React.useRef(null)

    React.useEffect(() => {
        if(player.current !== null) {
            console.log('seeking to', seek)
            player.current.seekTo(seek)
        }
        var wowza_player;
        if (islive) {
        (function () {
            function player_load() {
                // Get the player container to make it responsive or fixed width
                var el = document.getElementById('wowza_player');
                if(!el)
                    return
                // was a width specified in config? and if so, do we have a conflicting responsive setting?
                if (config.responsive == "true") {
                    // fail gracefully by removing the height attribute, as we set aspect ratio for responsive
                    if (config.height) {
                        delete config['height'];
                    }
                    if (config.width) {
                        delete config['width'];
                    }
                    // set the player to be responsive
                    // set the player to fill the width of it's container and maintain a 16:9 aspect ratio

                    el.setAttribute("style", "width:100%;padding:0 0 56.25% 0;height:0;");
                } else {
                    // maintian 16:9 aspect ratio
                    config.height = config.width * .5625; // Set player style for a fixed width player
                    el.style.width = config.width + "px";
                    el.style.height = config.height + "px";
                }
                // Call to the WSP js wrapper to render WSP in a div with the ID 'wowza_player' which we provide via the embed script
                if (window.WowzaPlayer) {
                    wowza_player = window.WowzaPlayer.create('wowza_player', config);
                    setVideoLoaded(true)
                    wowza_player.onMetadata(function (event) {
                        console.log('player event', event)
                    });
                }
            }

            // Load the WSP JS wrapper asynchorniously
            function load() {
                // var script = document.createElement('script');
                // script.type = 'text/javascript';
                // script.id = 'wowza-js'
                // script.async = true;
                // // once the script has loaded attach the player to a the 'wowza_player' div in the DOM
                // script.onload = player_load;
                // script.src = "https://s3.amazonaws.com/wcl-wowza-player/prod/latest/wowzaplayer.min.js"; // place script tag in document head
                // document.getElementsByTagName("head")[0].appendChild(script); // Insert the inline CSS so that we can style the player
                // var node = document.createElement('style');
                // node.innerHTML = '#wowza_player-CountdownTimer .wowza_player-Position-Center {\n height: 95px !important;\n width: 280px !important;\n font-size: 18px !important;\n top: 70px !important;\n left: 0 !important;\n font-weight: bold;\n line-height: 25px;\n padding-left: 40px;\n padding-top: 10px;\n border-radius: 0px 20px 20px 0px;\n background: rgba(0,0,0,0.5);\n color: #FFFFFF;\n z-index: 1000;\n}\n\n#wowza_player-CountdownTimer #wowza_player-CountdownTimerGroup {\n background: none;\n border: none;\n border-radius: none;\n top: 12px !important;\n left: -70px !important;\n}\n';
                // document.getElementsByTagName("head")[0].appendChild(node);
            }

            if (!videoLoaded) {
                load();
            }
        })();
        }
        if (document.getElementById('video-player')) {
            setWidth(document.getElementById('video-player').offsetWidth);
        }
        return () => {
            if (wowza_player)
            {
                wowza_player.destroy()
            }
            var scripts = document.getElementsByTagName('script');
            if (document.getElementById('wowza-js')) {
                document.getElementById('wowza-js').remove();
            }
            for (var i = scripts.length - 1; i--; i >= 0) {
                if (scripts[i].src.includes('wowzaplayer')) {
                    scripts[i].remove();
                }
            }
        }

    }, [seek])

    const [animation, setAnimation] = useState(false)

    const handleAnimate = (i) => {
        setAnimation(false)
        setTimeout(() => setAnimation(i), 100)
    }

    return (
        <div className={'video-player'} id="video-player" style={{overflow: 'hidden'}}>
            {islive ? <div id='wowza_player'/> : <ReactPlayer
              url={videoSource}
              width={'100%'}
              height={'83%'}
              ref={player}
              onPlay={handlePlay}
              onSeek={handleSetTime}
              onPause={handleStop}
              onProgress={handleOnProgress}
              controls={true}
              playing={true}
              config={{
                  file: {
                      attributes: {
                          onContextMenu: e => e.preventDefault(),
                          controlsList: 'nodownload'
                      }
                  }
              }}
            />}

            <div className="playerReactContainer" style={{position: 'relative'}} id={'emoji-container'}>
                <EmojiAnimation emoji={animation}/>
                <div id="video-area" style={{position: 'absolute', width: width * 0.9}}/>

                <div style={{width: '100%', textAlign: 'right', display: 'flex', justifyContent: 'center'}}>
                    {range(1, 8).map(i =>
                        <div key={i+''} className={`react-icon react-icon-${i} `}
                             onClick={() => handleAnimate(i)}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default memo(VideoPlayer);